import { render, staticRenderFns } from "./errcode.vue?vue&type=template&id=33f5b2bc&scoped=true&"
import script from "./errcode.vue?vue&type=script&lang=js&"
export * from "./errcode.vue?vue&type=script&lang=js&"
import style0 from "./errcode.vue?vue&type=style&index=0&id=33f5b2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5b2bc",
  null
  
)

export default component.exports